import React from 'react';
import useDragList from './useDragList';

export default function RoomsTable({ rooms, onChange, onDel }) {
  const change = (i, k, v) => {
    const next = rooms.slice();
    next[i] = { ...next[i], [k]: (k === 'name' ? v : (+v || 0)) };
    if (k === 'len' || k === 'wid') {
      const L = +next[i].len || 0, W = +next[i].wid || 0;
      const a = +(L * W).toFixed(2);
      if (a > 0) next[i].area = a;
    }
    onChange(next);
  };
  const reorder = (next) => onChange(next);
  const { onDragStart, onDragOver, onDrop, onDragEnd } = useDragList(rooms, reorder);

  return (
    <table className="zebra rt" id="tblAreas">
      <thead>
        <tr>
          <th style={{ width: 42 }}>№</th>
          <th>Помещение</th>
          <th style={{ width: 90 }}>Длина, м</th>
          <th style={{ width: 90 }}>Ширина, м</th>
          <th style={{ width: 120 }}>Площадь, м²</th>
          <th style={{ width: 130 }}>Тип пола</th>
          <th style={{ width: 80 }}>ТП</th>
          <th style={{ width: 130 }}>Стены, м²</th>
          <th style={{ width: 44 }} className="center">✖</th>
        </tr>
      </thead>
      <tbody>
        {(rooms || []).map((r, i) => (
          <tr key={i} draggable onDragStart={onDragStart(i)} onDragOver={onDragOver(i)} onDrop={onDrop(i)} onDragEnd={onDragEnd}>
            <td data-label="№"><div className="center"><span className="drag-handle">⋮⋮</span> {i + 1}</div></td>
            <td data-label="Помещение"><input value={r.name || ''} onChange={e => change(i, 'name', e.target.value)} /></td>
            <td data-label="Длина, м"><input type="number" step="0.01" value={r.len ?? ''} onChange={e => change(i, 'len', e.target.value)} /></td>
            <td data-label="Ширина, м"><input type="number" step="0.01" value={r.wid ?? ''} onChange={e => change(i, 'wid', e.target.value)} /></td>
            <td data-label="Площадь, м²"><input type="number" step="0.01" value={r.area ?? ''} onChange={e => change(i, 'area', e.target.value)} /></td>
            <td data-label="Тип пола">
              <select value={r.floor || 'lam'} onChange={e => change(i, 'floor', e.target.value)}>
                <option value="tile">Плитка/КГ</option><option value="lam">Ламинат/КВ</option>
              </select>
            </td>
            <td data-label="ТП"><div className="center"><input type="checkbox" checked={!!r.warm} onChange={e => change(i, 'warm', e.target.checked ? 1 : 0)} /></div></td>
            <td data-label="Стены, м²"><input type="number" step="0.01" value={r.wall ?? 0} onChange={e => change(i, 'wall', e.target.value)} /></td>
            <td data-label="Удалить" className="center"><button className="iconbtn" onClick={() => onDel(i)}>✕</button></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
